import { Box, Button, Paper, Stack, Typography } from "@mui/material";
import Grid2 from "@mui/material/Unstable_Grid2";
import CustomInput from "../../components/input/CustomInput";
import { useTranslation } from "react-i18next";
import { useContext, useEffect, useState } from "react";
import { useAccount } from "../../contexts/AccountContext";
import { useForm } from "react-hook-form";
import { InputReactHookForm } from "../../components/input/InputReactHookForm";
import { LayoutContext } from "../../contexts/LayoutContext";
import { account, common } from "../../i18n";
import { AvatarWithUpload } from "../../components/input/AvatarWithUpload";

export type ProfileFormValues = {
  name: string;
  displayName: string;
  jobTitle: string;
  phoneNumber: string;
  userProfile: string;
};

const Profile = () => {
  const { user, updateUser } = useAccount();

  const [userProfile, setUserProfile] = useState<string | undefined>(
    user?.userProfile ?? undefined,
  );

  const { t } = useTranslation([common, account], { nsMode: "fallback" });

  const {
    handleSubmit,
    control,
    watch,
    setValue,
    formState: { isSubmitting, isLoading },
  } = useForm<ProfileFormValues>({
    mode: "all",
    reValidateMode: "onChange",
    shouldUnregister: false,
  });

  const { setProfile } = useContext(LayoutContext);

  const onSubmit = async (values: ProfileFormValues) => {
    // const result = await updateUser(
    //   watch("name") ?? null,
    //   watch("displayName") ?? null,
    //   watch("phoneNumber") ?? null,
    //   watch("jobTitle") ?? null,
    //   userProfile ? userProfile : null
    // );
    // if (result) {
    //   setTimeout(() => {
    //     window.location.reload();
    //   }, 1500);
    // }

    updateUser(
      watch("name") ?? null,
      watch("displayName") ?? null,
      watch("phoneNumber") ?? null,
      watch("jobTitle") ?? null,
      userProfile ? userProfile : null,
    );

    setProfile(userProfile ? userProfile : undefined);
  };

  useEffect(() => {
    setValue("displayName", user?.displayName ?? "");

    setValue("name", user?.fullname ?? "");

    setValue("jobTitle", user?.jobTitle ?? "");

    setValue("phoneNumber", user?.phoneNumber ?? "");

    try {
      setUserProfile(user?.userProfile ?? undefined);
    } catch (error) {
      setUserProfile(undefined);
    }
  }, [user]);

  return (
    <Paper sx={{ padding: "20px" }} elevation={0} variant="outlined">
      <form onSubmit={handleSubmit(onSubmit)}>
        <Box
          sx={{
            height: "100%",
            width: "100%",
            overflow: "auto",
          }}
          display={"flex"}
          flexDirection={"column"}
          gap={"40px"}
        >
          <Box
            flex={1}
            sx={{
              overflow: "auto",
              height: "100%",
              width: "100%",
            }}
          >
            <Grid2
              container
              columnSpacing={{ xs: "0px", md: "40px" }}
              rowGap={"20px"}
              sx={{
                width: "100%",
              }}
            >
              <Grid2 gap={"20px"} xs={12} display={"flex"}>
                <AvatarWithUpload
                  avatar={userProfile ?? undefined}
                  displayName={user?.displayName ?? ""}
                  setAvatarChange={setUserProfile}
                />
                <Stack gap={"8px"} justifyContent={"center"}>
                  <Typography variant="h3">{t("Profile-Logo")}</Typography>
                  <Typography variant="text1" color={"var(--gray4)"}>
                    {t("Profile-Photo-Description")}
                  </Typography>
                </Stack>
              </Grid2>
              <Grid2 xs={12} md={6}>
                <InputReactHookForm
                  required
                  label={t("user-display-name")}
                  placeholder={t("user-display-name")}
                  name="displayName"
                  control={control}
                  rules={{
                    required: t("This-field-is-required", {
                      param: t("user-display-name"),
                    }),
                    pattern: {
                      value: /^[^,]*$/,
                      message: t("Name-Fails-To-Match-Pattern"),
                    },
                  }}
                  defaultValue=""
                />
              </Grid2>
              <Grid2 xs={12} md={6}>
                <InputReactHookForm
                  label={t("Name")}
                  placeholder={t("Name")}
                  name="name"
                  control={control}
                  defaultValue=""
                />
              </Grid2>
              <Grid2 xs={12} md={6}>
                <InputReactHookForm
                  label={t("Job-Title")}
                  placeholder={t("Job-Title")}
                  name="jobTitle"
                  control={control}
                  defaultValue=""
                />
              </Grid2>
              <Grid2
                xs={12}
                md={6}
                display={{ xs: "none", md: "grid" }}
              ></Grid2>
              <Grid2 xs={12} md={6}>
                <CustomInput
                  label={t("Email")}
                  required
                  disabled
                  value={user?.email ?? ""}
                />
              </Grid2>
              <Grid2 xs={12} md={6}>
                <InputReactHookForm
                  label={t("Phone")}
                  placeholder={t("Phone")}
                  name="phoneNumber"
                  control={control}
                  rules={{
                    pattern: {
                      value: /^[0-9]{10}$/,
                      message: t("Phone-Format-Invalid"),
                    },
                  }}
                  defaultValue=""
                />
              </Grid2>
            </Grid2>
          </Box>

          <Button
            variant="contained"
            color="secondary"
            type="submit"
            disabled={isSubmitting || isLoading}
          >
            {t("Save")}
          </Button>
        </Box>
      </form>
    </Paper>
  );
};

export default Profile;
